import config from "../../config"
import RequestService from "../RequestService"

const updateWorkflowStep = (id, values, successCallback, failureCallback) => {
  RequestService.patch(`${config.backendUrl}/workflow_steps/${id}`, {workflow_step: values}, successCallback, failureCallback)
}

export default updateWorkflowStep;